"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _config = require("../../utils/config");

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

var delay = function delay(next) {
  var timer;
  return function (params) {
    clearTimeout(timer);

    var dataCount = params.dataCount,
        isSaveFailed = params.isSaveFailed,
        others = _objectWithoutProperties(params, ["dataCount", "isSaveFailed"]);

    if (isSaveFailed) {
      // 数据保存失败
      return next(Object.assign({}, others, {
        isSaveFailed: isSaveFailed
      }));
    }

    var _getConfig = (0, _config.getConfig)(),
        reportMaxCount = _getConfig.reportMaxCount,
        reportDelay = _getConfig.reportDelay;

    if (dataCount > reportMaxCount) {
      // 条数达到限制 立即上报
      return next(others);
    } // 延时上报


    return timer = setTimeout(function () {
      next(others);
      clearTimeout(timer);
    }, reportDelay);
  };
};

var _default = delay;
exports.default = _default;